"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { withSlotScopeClasses } from '../../helpers/scoped-slots.mjs';
import { tv } from 'tailwind-variants';

const dataBuilderRowRecipe = tv({
  slots: withSlotScopeClasses("data-builder-row", {
    row: "w-full relative flex flex-row flex-nowrap items-stretch justify-start"
  }),
  variants: {
    span: {
      short: { row: "w-fit" },
      default: {}
    }
  }
});
function Row({ children, className, span, ...rest }) {
  const styles = dataBuilderRowRecipe({ span });
  return /* @__PURE__ */ jsx("div", { className: styles.row({ className }), ...rest, children });
}

export { Row };
